<app-header></app-header>

<!--============ Breadcumb ============= -->
<div class="breadcumb-wrapper" data-bg-src="assets/img/bg/breadcumb-bg.jpg">
    <div class="container">
        <div class="breadcumb-content">
            <h1 class="breadcumb-title">Android Development</h1>
            <ul class="breadcumb-menu">
                <li><a routerLink="/">Home</a></li>
                <li>Android Development</li>
            </ul>
        </div>
    </div>
</div>

<section class="space">
    <div class="container">
        <div class="row">
            <div class="col-xxl-8 col-lg-7">
                <div class="page-single">
                    <div class="service-img sv-details-img">
                        <img class="w-100" src="assets/img/service/development.webp" alt="Android Development" />
                    </div>
                    <div class="page-content sv-content d-block">
                        <h2 class="box-title">Android Development</h2>
                        <p class="box-text mb-30">The android development process typically involves designing the user
                            interface (UI), implementing app functionality, handling user input, accessing device
                            features such as cameras or sensors, and managing data storage and retrieval. Android
                            developers use integrated development environments (IDEs) like Android Studio, which provide
                            a comprehensive set of tools for writing, debugging, and testing Android apps.
                        </p>
                        <div class="sv-gallery-wrapper">
                            <h2 class="box-title">Why Android Development Important?</h2>
                            <p>Here are some key points to consider when it comes to mobile development:</p>
                            <div class="row gy-4">
                                <div class="col-6">
                                    <div class="sv-sm-img">
                                        <img class="w-100" src="assets/img/service/video-image-1.jpg.webp" alt="" />
                                    </div>
                                </div>
                                <div class="col-6 my-5">
                                    <div class="checklist tick-checklist sv-details-list mb-40">
                                        <ul class="list">
                                            <li>Platform Selection</li>
                                            <li>Native vs. Cross-Platform Development</li>
                                            <li>Development Tools and Technologies</li>
                                            <li>User Interface and User Experience (UI/UX)</li>
                                            <li>Backend Integration</li>
                                            <li>Testing and Quality Assurance</li>
                                            <li>Deployment and Distribution</li>
                                            <li>Post-Launch Maintenance</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row gy-4">
                                <div class="col-12">
                                    <p>Overall, Android development offers a robust platform for creating innovative and
                                        engaging mobile applications that can reach a large user base on Android devices
                                        worldwide.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xxl-4 col-lg-5">
                <app-service-sidebar></app-service-sidebar>
            </div>
        </div>
    </div>
</section>

<!--======== Footer Section ========-->
<app-footer></app-footer>